import { render, staticRenderFns } from "./GroupEditorControl.vue?vue&type=template&id=39dce0ba&scoped=true"
import script from "./GroupEditorControl.vue?vue&type=script&lang=js"
export * from "./GroupEditorControl.vue?vue&type=script&lang=js"
import style0 from "./GroupEditorControl.vue?vue&type=style&index=0&id=39dce0ba&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39dce0ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('39dce0ba')) {
      api.createRecord('39dce0ba', component.options)
    } else {
      api.reload('39dce0ba', component.options)
    }
    module.hot.accept("./GroupEditorControl.vue?vue&type=template&id=39dce0ba&scoped=true", function () {
      api.rerender('39dce0ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/GroupEditorControl.vue"
export default component.exports